import { PulseLoader } from "react-spinners"
import { Button, Input, InputGroupText, Label, Modal, ModalHeader } from "reactstrap"
import styled from "styled-components"

export const StyledModalHeader = styled(ModalHeader)`
font-family:'Lato', sans-serif;
color: #fff;
`

export const StyledLabel = styled(Label)`
font-family: 'Lato', sans-serif;

`

export const StyledSpan = styled.span`
cursor: "pointer";

`

export const StyledButton = styled(Button).attrs(() => ({
    className: "btn-block btn-lg bg-header hover:bg-header border-0 text-white"
}))`
color: "white";

`

export const StyledInputGroup = styled(InputGroupText).attrs(() => ({
    addontype: "prepend"
}))`
 padding: 0,
          paddingLeft: "6px",
          paddingRight: "6px",";

`
export const StyledIcon = styled.i.attrs(({ icon }) => ({
    className: icon
}))`

        font-size: 28px;
        color: #adb5bd;
    

`

export const StyledInput1 = styled(Input).attrs(() => ({
    disabled: true,
    type: "text"
}))`
    padding-left: 5px;
    padding-right: 5px;
    font-size: 18px;
    color: #8898aa;
    background-color: white;
`;


export const StyledInput3 = styled.input.attrs(() => ({
    className: ""
}))`

`
export const StyledInput2 = styled(Input)`
    padding-left: 5px;
    padding-right: 5px;
    font-size: 18px;
`


export const StyledModal = styled(Modal).attrs(() => ({
    className: "modal-xl spinner-modal h-100", backdrop: true, isOpen: true, fade: false
}))`
display: grid;
place-items: center;
margin-top: 0;
margin-bottom: 0;

`

export const StyledPulseLoader = styled(PulseLoader).attrs(() => ({
    className: "modal-xl spinner-modal h-100", backdrop: true, isOpen: true, fade: false
}))`
display: grid;
place-items: center;
margin-top: 0;
margin-bottom: 0;

`